import React from "react";
import {Typography} from "@material-ui/core";

export const team = [
    {
        title: 'CEO / Co-Founder',
        authorPhoto: {
            src: 'https://media.graphcms.com/output=format:jpg/resize=,height:800,fit:max/EuQxGg1lRxWMX2sCQfgU',
        },
        text: <Typography variant={'body2'}>
            Craig is Co-Founder & CEO of REVLOCK. Craig started his career with Arthur Andersen where he led several
            practices including the Pittsburgh Office’s Capital Markets practice.
            Craig has deep experience as a business advisor, investor, entrepreneur and CEO.
        </Typography>,
        authorName: 'Craig Kirsch, CPA',
    },
    {
        title: 'CPO',
        authorPhoto: {
            src: 'https://media.graphcms.com/output=format:jpg/sspp7ewwQvaTFcExl33h',
        },
        text: <Typography variant={'body2'}>
            Umar is responsible for the product strategy, vision and development. He has several decades of experience
            building products to help optimize the finance function in both large and small companies.
        </Typography>,
        authorName: 'Umar Syyid',
    },
    {
        title: 'CRO',
        authorPhoto: {
            src: 'https://media.graphcms.com/output=format:jpg/uJ2YTAsLT6ulxLLxyrAW',
        },
        text: <Typography variant={'body2'}>
            Jeff is the Chief Revenue Officer of REVLOCK, responsible for overall growth of the product. He has over 25
            years of experience in software sales. In the past 15 years, Jeff has started and successfully grown multiple SaaS companies
        </Typography>,
        authorName: 'Jeff Sant',
    },
    {
        title: 'CTO',
        authorPhoto: {
            src: 'https://media.graphcms.com/output=format:jpg/resize=,height:800,fit:max/ZU5rPa3nR2W4pYoqaoVS',
        },
        text: <Typography variant={'body2'}>
            Irfan is the Chief Technology Officer of REVLOCK.

            He has over 20 years of experience in the software industry with a focus on building enterprise systems
            focused on helping companies modernize their finance functions.
        </Typography>,
        authorName: 'Irfan Zulfiqar',
    },
    {
        title: 'ASC/606 Expert',
        authorPhoto: {
            src: 'https://media.graphcms.com/output=format:jpg/resize=,height:800,fit:max/JAdgKlksRJWTp1ROP0ds'
        },
        text: <Typography variant={'body2'}>
            Tony is a Co-Founder of RevLock. Tony brings more than 27 years of experience in public accounting as a
            partner in large international accounting firms.
        </Typography>,
        authorName: 'Tony Ricciardella, CPA',
    }
];

export const mapData = [
    {
        location: {
            x: 38.9784352, y: -77.0916512, address: '6900 Wisconsin Ave #200, Bethesda MD',
        },
    }
];


